module.exports = __webpack_public_path__ + "carat.2bb0c23f8dc2e6af67c22d1ce3e4e03b.svg";